import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/Login.vue'
import Install from '../views/install/Install.vue'
import Viplist from '../views/vip/Viplist.vue'
import InstallData from '../views/install/InstallData.vue'
import Installmian from '../views/install/Installmian.vue'
import Installperpo from '../views/install/Installperpo.vue'
import Vipmessage from '../views/vip/Vipmessage.vue'
import Goodslist from '@/views/goods/Goodslist.vue'
import OrderList from '@/views/order/OrderList.vue'
import OrderDetails from '@/views/order/OrderDetails.vue'
import Shop from '@/views/Shops/Shop.vue'
import ShopDetails from '@/views/Shops/ShopDetails.vue'
import ShingCharge from '@/views/chingcharge/ShingCharge.vue'
import AddCharge from '@/views/chingcharge/AddCharge.vue'
import GoodAdd from '@/views/goods/GoodAdd.vue'
import Installadd from "@/views/install/Installadd.vue"
import Installrole from '@/views/install/Installrole.vue'
import Roleadd from '@/views/install/Roleadd.vue'
import OrderJf from '@/views/order/OrderJf.vue'
import Test from '@/views/test.vue'
import EventsChang from '@/views/events/EventsChang'
import EventsGoods from '@/views/events/EventsGoods'
import Description from '@/views/goods/Description'
import Category from '@/views/goods/Category'
import MessageList from '@/views/message/MessageList'
import StandardList from '@/views/standard/StandardList.vue'
import StanderdMsg from '@/views/standard/StanderdMsg.vue'
import Capital from '@/views/capital/CapitalList.vue'
import CapitalMeg from '@/views/capital/CapitalMeg.vue'
import GoodyList from '@/views/libao/GoodyList.vue'
import GoodyMsg from '@/views/libao/GoodyMsg.vue'
import FenXiao from '@/views/fenxiao/FenXiao.vue'
import FenList from '@/views/fenxiao/FenList.vue'
import FenPai from '@/views/fenxiao/FenPai.vue'
import PinList from "@/views/goods/PinList.vue"
const routes = [
  {
    path: "/:catchAll(.*)",
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/home/viplist',
    component: HomeView,
    children: [
      {
        path: '/home/install',
        name: 'install',
        component: Install,
        children: [
          {
            path: '/home/install/installData',
            name: 'InstallData',
            meta: {
              keepAlive: true //设置页面是否需要使用缓存
            },
            component: InstallData
          },
          {
            path: '/home/install/installperpo',
            name: 'Installperpo',
            meta: {
              keepAlive: true //设置页面是否需要使用缓存
            },
            component: Installperpo

          },
          {
            path: '/home/install/installmian',
            name: 'Installmian',
            component: Installmian

          },
          {
            path: '/home/install/installrole',
            name: 'installrole',
            component: Installrole
          }
        ]
      },
      {
        path: '/home/install/roleadd',
        name: 'roleadd',
        component: Roleadd
      },
      {
        path: '/home/installadd',
        name: 'installadd',
        component: Installadd
      },
      {
        path: '/home/viplist',
        name: 'viplist',
        component: Viplist
      },
      {
        path: '/home/viplist/vipmeessage',
        name: 'vipmeessage',
        component: Vipmessage
      },
      {
        path: '/home/goodlist',
        name: 'goodlist',
        component: Goodslist
      },
      {
        path: '/home/goodlist/PinList',
        name: 'PinList',
        component: PinList
      },
      {
        path: '/home/goodlist/description',
        name: 'description',
        component: Description
      },
      {

        path: '/home/goodlist/Category',
        name: 'Category',
        component: Category
      },
      {
        path: '/home/orderlist',
        name: 'orderlist',
        component: OrderList
      },
      {
        path: '/home/orderlist/orderdetail',
        name: 'orderdetail',
        component: OrderDetails
      },
      {
        path: '/home/orderlist/Orderjf',
        name: 'OrderJf',
        component: OrderJf
      },
      {
        path: '/home/shop',
        name: 'shop',
        component: Shop
      },
      {
        path: '/home/shopDetails',
        name: 'shopDetails',
        component: ShopDetails
      },
      {
        path: '/home/shingcharge',
        name: 'shingcharge',
        component: ShingCharge,

      },
      {
        path: '/home/shingcharge/addCharge',
        name: 'addCharge',
        component: AddCharge,
      },
      {
        path: '/home/events/goods',
        name: 'eventsGoods',
        component: EventsGoods


      },
      {
        path: '/home/events/chang',
        name: 'eventsChang',
        component: EventsChang

      },

      {
        path: '/home/message',
        name: 'message',
        component: MessageList
      },
      {
        path: '/home/standard',
        name: 'standard',
        component: StandardList
      },
      {
        path: '/home/standard/standerdmsg',
        name: 'standerdmsg',
        component: StanderdMsg
      },
      {
        path: '/home/capital',
        name: 'Capital',
        component: Capital
      },
      {
        path: '/home/capital/capitalMeg',
        name: 'capitalMeg',
        component: CapitalMeg
      },

      {
        path: '/home/goody',
        name: 'goodyList',
        component: GoodyList
      },
      {
        path: '/home/goody/goodymsg',
        name: 'goodyMsg',
        component: GoodyMsg
      },
      {
        path: '/home/fenxiao',
        name: 'fenxiao',
        component: FenXiao
      },
      {
        path: '/home/fenxiao/fenlist',
        name: 'fenlist',
        component: FenList
      },
      {
        path: '/home/fenxiao/fenpai',
        name: 'fenpai',
        component: FenPai
      }
    ]
  },
  {
    path: '/home/goodlist/goodadd',
    name: 'goodadd',
    component: GoodAdd
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/test',
    name: 'test',
    component: Test
  }
]


const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach((to, from, next) => {
  let adminPermList
  let adminPermLists
  let admin
  if (localStorage.getItem('usermassage') && JSON.parse(localStorage.getItem('usermassage')).adminPermList != null) {
    adminPermList = JSON.parse(localStorage.getItem('usermassage'))
    adminPermLists = adminPermList.adminPermList
    console.log('adminPermList', adminPermLists)
    admin = adminPermLists.filter(item => item.permPathLevel == 1)
  }
  // console.log('from',from)
  console.log('to', to.path)
  console.log('admin', admin)
  // 判断有没有登录
  if (!localStorage.getItem('token')) {
    if (to.name == "login") {
      next();
    }  else {
      router.push('/login')
    }
  } else {
    if (to.name == "login" || to.name == 'message' || to.name == "fenxiao" ) {
      next();
    } else {
      if (admin) {
        let haspermPath = admin.some(item => to.path.includes(item.permPath))
        console.log('haspermPath', haspermPath)
        if (haspermPath) {
          next();
        } else {
          router.push(from.path)
        }
      } else {
        if (from.name == 'login') {
          next()
        } else {
          router.push('/login')
        }
      }

    }
  }
});
export default router
